export default "__VITE_ASSET__BeK_KIEF__"